import "./Technology.css";
import Footer from "./Footer";
import productImg from "../assets/product-tech.JPG";

export default function TechProduct() {
    return (
        <section id="tech-product">
            {/* TOP SECTION */}
            <div className="technology-wrapper-a">
                <div className="technology-text-a">
                    <h3>Product</h3>
                    <h3>
                        Lightweighting Through Material, Process and Design Optimization
                    </h3>

                    <p>
                        SCL offers lightweight design solutions to OEM, thanks to a broad range of casting processes, machining and assembly capabilities and design experience. Value adding solutions, developed and delivered to our customer over decades, confirming the preferred position as global partner in the automotive industry.
                    </p>
                </div>
            </div>

            <h2 className="technology-title">Collaboration in Product Development</h2>
            <div className="tech-underline"></div>
            <p style={{ textAlign: "center", margin: "30px 220px" }}>
                Each of these approaches showcases our commitment to lightweight, high-performance product engineering:
            </p>

            <div className="img-grid-single">
                <img src={productImg} alt="Product Technology" />
            </div>

            <div className="tech-wrapper">
                {/* CARD 1 */}
                <div className="tech-card">
                    <div className="tech-header">
                        1. Alternate Processes
                    </div>
                    <div className="tech-body">
                        <p>
                            From stamping to casting and finding the optimal casting process. SCL is adding value through integration. Less interfaces means less weight and lower costs, which is the case, when we change a sheet metal component into a single casting.
                        </p>
                        <p>
                            Re-designing a gravity casting into a high-pressure die casting component, can result in decent weight reduction and cost reductions through less machining.
                        </p>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="tech-card">
                    <div className="tech-header">
                        2. Lightweight Material
                    </div>
                    <div className="tech-body">
                        <p>
                            Changing iron and steel to aluminium casting. Gaining a weight reduction of up to 50% can be achieved through switching from Iron or Steel to Aluminium. SCL has the know-how to do that in collaboration with our customers.
                        </p>
                    </div>
                </div>

                {/* CARD 3 */}
                <div className="tech-card">
                    <div className="tech-header">
                        3. Design Optimization
                    </div>
                    <div className="tech-body">
                        <p>
                            Form follows function – SCL is using topological optimization techniques and FEA simulation tools to optimize the design with respect to strength, stiffness, durability and NVH requirements. As a result, we can offer weight reduction through design optimization, resulting in lower fuel consumption and a positive contribution to a lower CO2 footprint.
                        </p>
                    </div>
                </div>
            </div>

            <p style={{ textAlign: "center", margin: "30px 220px" }}>
                Our customers are benefitting of a one-stop solution through SCL, from prototype over product development to the final series production.
            </p>

            <Footer />
        </section>
    );
}